(() => {
  if (window.transformationTimelineInitialized) return;

  window.transformationTimelineInitialized = true;
  const rootSelector = '[data-transformation-timeline]';

  const initializeVideo = (root, item) => {
    if (item.dataset.transformationVideoInitialized === 'true') return;

    const video = item.querySelector('video');
    const playbackButton = item.querySelector('[data-transformation-video-toggle]');
    const muteButton = item.querySelector('[data-transformation-video-mute]');

    if (!video || !playbackButton || !muteButton) return;

    item.dataset.transformationVideoInitialized = 'true';
    let controlsTimeout;

    const updatePlaybackState = () => {
      const isPlaying = !video.paused && !video.ended;

      item.classList.toggle('is-playing', isPlaying);
      playbackButton.setAttribute('aria-label', isPlaying ? root.dataset.pauseVideoLabel : root.dataset.playVideoLabel);
      playbackButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    };

    const updateMuteState = () => {
      item.classList.toggle('is-muted', video.muted);
      muteButton.setAttribute('aria-label', video.muted ? root.dataset.unmuteVideoLabel : root.dataset.muteVideoLabel);
      muteButton.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
    };

    const togglePlayback = () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    };

    const showControls = () => {
      window.clearTimeout(controlsTimeout);
      item.classList.add('is-controls-visible');
      controlsTimeout = window.setTimeout(() => item.classList.remove('is-controls-visible'), 2500);
    };

    playbackButton.addEventListener('click', (event) => {
      event.stopPropagation();
      togglePlayback();
      showControls();
    });

    muteButton.addEventListener('click', (event) => {
      event.stopPropagation();

      if (video.muted) {
        document.querySelectorAll('[data-transformation-video] video').forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.muted = true;
        });
      }

      video.muted = !video.muted;
      updateMuteState();
      showControls();
    });

    video.addEventListener('click', () => {
      togglePlayback();
      showControls();
    });
    video.addEventListener('play', updatePlaybackState);
    video.addEventListener('pause', updatePlaybackState);
    video.addEventListener('ended', updatePlaybackState);
    video.addEventListener('volumechange', updateMuteState);

    video.muted = true;
    video.defaultMuted = true;
    updatePlaybackState();
    updateMuteState();
    video.play().catch(() => {});
  };

  const initializeSection = (root) => {
    root.querySelectorAll('[data-transformation-video]').forEach((item) => initializeVideo(root, item));
  };

  document.querySelectorAll(rootSelector).forEach(initializeSection);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(rootSelector).forEach(initializeSection);
  });
})();
